import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Button,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const Contact = () => {
  const phoneNumber = "+919003708823";
  const whatsappMessage = "Hello, I would like to know more about Kulche Shulche!";
  const facebookLink = "https://www.facebook.com/kulcheshulche";
  const instagramLink = "https://www.instagram.com/kulcheshulche";
  const email = "kulcheshulche@gmail.com";
  const address = "L-10, Indraprasth, City Light, Surat, Gujarat, India";

  return (
    <Box sx={{ bgcolor: "#FFF8E1", py: 6 }}>
      <Container>
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          color="#D35400"
          gutterBottom
        >
          Contact Us
        </Typography>

        <Grid container spacing={4} justifyContent="center" sx={{ my: 4 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: 4, boxShadow: 3 }}>
              <Typography variant="h6" fontWeight="bold" mb={2}>
                Kulche Shulche
              </Typography>

              <Typography variant="body1" mb={1}>
                <strong>Phone:</strong> {phoneNumber}
              </Typography>
              <Typography variant="body1" mb={1}>
                <strong>Email:</strong> {email}
              </Typography>
              <Typography variant="body1" mb={2}>
                <strong>Address:</strong> {address}
              </Typography>

              <Button
                variant="contained"
                color="success"
                startIcon={<WhatsAppIcon />}
                href={`https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(
                  whatsappMessage
                )}`}
                target="_blank"
                fullWidth
                sx={{ mb: 2 }}
              >
                Chat on WhatsApp
              </Button>

              <Box display="flex" justifyContent="center" gap={2}>
                <IconButton
                  component="a"
                  href={facebookLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "#3b5998" }}
                >
                  <FacebookIcon />
                </IconButton>
                <IconButton
                  component="a"
                  href={instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: "#E1306C" }}
                >
                  <InstagramIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
